import { agentFetch } from "../agentFetch";
import { parseAgentServiceError } from "../../utils/agentErrors";
import { agentApiBase } from "../../utils/agentApiBase";

interface SessionInitBody {
  sessionId?: string;
  session_id?: string;
}

export async function createAgentRunnerSession(agentId: string): Promise<string> {
  const base = await agentApiBase(agentId);
  const response = await agentFetch(`${base}/session`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({}),
  });
  if (!response.ok) {
    throw await parseAgentServiceError(
      response,
      `Failed to create ${agentId} session`,
    );
  }
  const data = (await response.json()) as SessionInitBody;
  const sessionId =
    data.sessionId ??
    data.session_id ??
    response.headers.get("session-id");
  if (!sessionId) {
    throw new Error(`Failed to create ${agentId} session: missing sessionId`);
  }
  return sessionId;
}

export async function pingAgentRunnerSession(
  agentId: string,
  sessionId: string,
): Promise<boolean> {
  const base = await agentApiBase(agentId);
  const response = await agentFetch(
    `${base}/session/${encodeURIComponent(sessionId)}/stats?verbose=false`,
    { method: "GET" },
  );
  if (response.status === 404) return false;
  if (!response.ok) {
    throw await parseAgentServiceError(
      response,
      `Failed to verify ${agentId} session`,
    );
  }
  return true;
}
